<template>
  <div class="elements-list" v-if="withSearch">
    <slot />
  </div>

  <div v-else class="elements-list-wrapper">
    <TextBody
      v-if="fieldConfig.optionList?.length && unavailableFilterValues?.length"
      i18n-key="assist.filters.selectFilters"
      color="#6A6765"
      tag="span"
    />
    <div class="elements-list">
      <slot />
    </div>
    <TextBody
      v-if="unavailableFilterValues?.length"
      i18n-key="assist.filters.notAvailableFilters"
      color="#6A6765"
      tag="span"
    />
    <div class="elements-list" v-if="unavailableFilterValues?.length">
      <FilterLabel v-for="option in unavailableFilterValues" :key="option.id" :label="option.label" :disabled="true" />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { computed, ref } from 'vue';

import TextBody from '~/components/common/TextBody.vue';
import components from '~/services/filter-form-service/components';
import FilterLabel from '~/components/filters/FilterLabel.vue';

export default {
  components: { FilterLabel, TextBody, ...components },
  props: {
    withSearch: {
      type: Boolean,
      default: false,
    },
    filtersConfig: {
      type: Array,
      default: () => [],
      required: true,
    },
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Array,
      default: () => [],
      required: true,
    },
    selectedFilterType: {
      type: String,
      default: '',
      required: true,
    },
    unavailableFilterValues: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const filterValue = ref('');
    const filteredValues = computed(() =>
      props.fieldConfig.optionList?.filter((item) =>
        item.label.toLowerCase().includes(filterValue.value.toLowerCase()),
      ),
    );

    const toggleValue = (value) => {
      const newValues = props.values?.includes(value)
        ? props.values.filter((v) => v !== value)
        : [...props.values, value];
      emit('update:values', newValues);
    };

    return {
      t,
      filterValue,
      filteredValues,
      toggleValue,
    };
  },
};
</script>

<style lang="scss" scoped>
.elements-list {
  display: flex;
  height: fit-content;
  gap: $bb-spacing-4;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 30px 0 6px 0;
  padding: 0 $bb-spacing-4;
  flex: 2;
  overflow: auto;
  max-height: 300px;
  width: 100%;
}

.filters-container {
  display: flex;
  flex-direction: row;
  gap: $bb-spacing-6;
  padding: $bb-spacing-3 $bb-spacing-4;

  .element-types-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: $bb-spacing-1;

    :deep(.element-type) {
      background-color: $bb-neutral-6 !important;
      border-radius: 100px;
      height: 36px;

      div {
        font-size: 15px;
      }
    }

    :deep(.selected) {
      background-color: $bb-primary-1 !important;

      div {
        color: $bb-neutral-0 !important;
      }
    }

    :deep(.element-type .selected-label) {
      border: unset;
      background-color: unset;

      div {
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        text-overflow: unset;
        max-width: unset;
      }
    }
  }
}

.elements-list-wrapper {
  display: flex;
  flex-direction: column;
  flex: 3;
  gap: $bb-spacing-3;
  overflow: auto;
  max-height: 400px;

  .elements-list {
    display: flex;
    height: fit-content;
    gap: $bb-spacing-1;
    flex-wrap: wrap;
    flex-direction: row;
    flex-direction: row;
    margin: 0;

    :deep(.bb-btn.secondary) {
      border-radius: 100px !important;
      padding: 10px $bb-spacing-4 !important;
      height: $bb-spacing-9 !important;
    }

    :deep(.v-btn__content) {
      font-size: 12px !important;
      text-transform: capitalize;
    }

    :deep(.selected) {
      border: 1px solid $bb-primary-3 !important;
    }

    .smaller-elements {
      :deep(.bb-btn.secondary) {
        padding: $bb-spacing-2 !important;
        height: $bb-spacing-6 !important;
      }

      :deep(.v-btn__content) {
        gap: $bb-spacing-1 !important;
      }
    }
  }
}
</style>
